import { render, staticRenderFns } from "./vHeader.vue?vue&type=template&id=c7dc4038&scoped=true"
import script from "./vHeader.vue?vue&type=script&lang=js"
export * from "./vHeader.vue?vue&type=script&lang=js"
import style0 from "./vHeader.vue?vue&type=style&index=0&id=c7dc4038&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7dc4038",
  null
  
)

export default component.exports